import React, { Component, PropTypes } from 'react';
import { FormGroup, HelpBlock, ControlLabel, FormControl } from 'react-bootstrap';

export default class FormField extends Component {
    render() {
      const { id, input, label, type, meta: { error, touched, invalid } } = this.props;

      return (
        <FormGroup controlId={id}>
          <ControlLabel>{label}</ControlLabel>
          <FormControl
            {...input}
            type={type}
          />
          <HelpBlock>{touched && error && `*${error}`}</HelpBlock>
        </FormGroup>
      );
    }
}



// WEBPACK FOOTER //
// ./src/components/login/FormField.jsx